import { apiCall, ApiResponse } from "./apiClient";
import { GenericNotificationDto, NotificationListQueryParameters } from "../models/notification/notification";

export const getNotifications = (qsp?: NotificationListQueryParameters): Promise<ApiResponse<GenericNotificationDto[]>> => {
    return apiCall<GenericNotificationDto[]>("Notifications", "GET", qsp);
};

export const confirmNotification = (id: string): Promise<ApiResponse<GenericNotificationDto>> => {
    return apiCall<GenericNotificationDto>(`Notifications/${id}/confirm`, "PUT");
};